:host {
  display: block;
  max-width: 100%;
  height: 100%;
}

:host([complexPopup]) {
  .feedback-form-wrapper {
    .feedback-form-content {
      padding: calc(3 * var(--spacer)) calc(5 * var(--spacer));
      width: 560px;
    }
  }

  .action-buttons {
    padding: 0 calc(5 * var(--spacer));
    min-height: 60px;
    margin-top: auto;
    box-shadow: 0 0 4px var(--chart-104-pressed);
  }
}

.feedback-form-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  .text-area-input {
    max-width: 560px;
  }
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

gz-textarea {
  --max-height-textarea: 300px;
  --input-height: 64px;
}

.input-field-hidden {
  display: none;
}

gz-form-field[id="feedBackInput"] {
  --form-field-label-width: 190px;

  &::part(form-field-label) {
    font-size: var(--body-size-large);
  }
}
